import { Id, Tag } from "@planzone/dto";
import { HttpClient, HttpMethods } from "@planzone/services";
import { LinkedTask } from "../linkers/types";

function addTagToTask(httpClient: HttpClient) {
  return (tag: Tag, taskId: Id) =>
    httpClient
      .sendHttpRequest<LinkedTask>({
        endpoint: `/tasks/${taskId}`,
        method: HttpMethods.GET,
      })
      .then((task) =>
        httpClient.sendHttpRequest<void>({
          endpoint: `/tasks/${taskId}`,
          method: HttpMethods.PATCH,
          data: { tags: [...task.tags, tag.name] },
        }),
      );
}

export { addTagToTask };
